import Rx from '@evo/rx';
import { GET, POST } from '@evo/fetch-io';

import { Config } from './../core/config';
import * as c from './constants';
import * as a from './actions';

export function loadServerPow(stream) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    const POW_DATA_URL = `${DEFAULT_ORIGIN}/remote/registration/pow_data`;

    return GET(
        POW_DATA_URL
    ).then(({ powInit, powPath }) => {
        stream.send(a.TR_LOAD_SERVER_POW_SUCCESS, { powInit, powPath });
    }).catch(() => {
        stream.send(a.TR_LOAD_SERVER_POW_FAIL);
        return Rx.Observable.empty();
    });
}

export function authenticateUser(rawLoginData) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    const BASE_CABINET_URL = `${DEFAULT_ORIGIN}/cabinet`;
    const USER_AUTH_DATA_URL = `${BASE_CABINET_URL}/auth/phone_login`;

    return (stream) => {
        return POST(
            USER_AUTH_DATA_URL,
            rawLoginData,
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }
        ).then((response) => {
            stream.send(a.TR_AUTHENTICATE_USER_SUCCESS, response);
        }).catch((err) => {
            stream.send(a.TR_AUTHENTICATE_USER_FAIL, err);
            return Rx.Observable.empty();
        });
    };
}

export function registerUser(formData) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    const USER_REGISTER_URL = `${DEFAULT_ORIGIN}/remote/registration/register_customer`;

    return (stream) => {
        return POST(
            USER_REGISTER_URL,
            JSON.stringify(formData),
        )
        .then((response) => {
            if (response.status === 'ok') {
                stream.send(a.TR_REGISTER_USER_SUCCESS);
                stream.send(a.TR_SEND_ANALITICS_ACTION,
                    { action: c.ANALCS_ACTION_REGISTER_FINISH });
            } else stream.send(a.TR_REGISTER_USER_FAIL, response);
        })
        .catch((response) => {
            stream.send(a.TR_REGISTER_USER_FAIL, response);
            return Rx.Observable.empty();
        });
    };
}

export function requestClientInfo(ident) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    const GET_CLIENT_DATA_URL = `${DEFAULT_ORIGIN}/remote/besida/get_client`;

    return (stream) => {
        return GET(
            GET_CLIENT_DATA_URL,
            { id: ident }
        ).then(({ client }) => {
            stream.send(a.TR_GET_CLIENT_INFO_SUCCESS, { client });
        }).catch(() => {
            stream.send(a.TR_GET_CLIENT_INFO_FAIL);
            return Rx.Observable.empty();
        });
    };
}

export function requestCompanyInfo(ident) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    const GET_COMPANY_DATA_URL = `${DEFAULT_ORIGIN}/remote/besida/get_company`;

    return (stream) => {
        return GET(
            GET_COMPANY_DATA_URL,
            { id: ident }
        ).then(({ company }) => {
            stream.send(a.TR_GET_COMPANY_INFO_SUCCESS, { company });
        }).catch(() => {
            stream.send(a.TR_GET_COMPANY_INFO_FAIL);
            return Rx.Observable.empty();
        });
    };
}
